import React from "react";
import { HStack, Image, Text, VStack } from "native-base";
import sprinter from "../../assets/images/sprinter.png";
import volvo from "../../assets/images/volvo.png";
import multego from "../../assets/images//multego.png";

function Vehicles() {
  return (
    <HStack justifyContent="space-evenly">
      <VStack alignItems="center">
        <Image src={sprinter} alt="sprinter" width={240} height={115} />
        <Text fontSize="xl">15 asientos</Text>
      </VStack>
      <VStack alignItems="center">
        <Image src={multego} alt="multego" width={240} height={115} />
        <Text fontSize="xl">44 asientos</Text>
      </VStack>
      <VStack alignItems="center">
        <Image src={volvo} alt="volvo" width={240} height={115} />
        <Text fontSize="xl">52 asientos</Text>
      </VStack>
    </HStack>
  );
}

export default React.memo(Vehicles);
